const handleCatchError = (error: unknown, errorMessage = 'Unknown error') => {
  if (error instanceof Error) {
    throw error;
  } else {
    throw new Error(errorMessage);
  }
};

export default handleCatchError;
